export default __webpack_public_path__ + "static/media/logo.93bc40ef.jpg";